export default "__VITE_ASSET__DwSgVasB__"